import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";

import { Box, Typography, Button } from "@mui/material";

import { getRefreshedBearerToken } from "services/utility/authentication";

import { setCompany } from "globalState/userCompanySettingsSlice";

export function SupportActivationUserWarning() {
  const dispatch = useDispatch();

  const needsCompanyChooser = useSelector(
    (state) => state.authentication.needsCompanyChooser
  );
  const companies = useSelector(
    (state) => state.userCompanySettings.companies
  ).filter(({ supportUser }) => !supportUser);

  const company = useSelector((state) => state.userCompanySettings.company);

  const navigate = useNavigate();

  async function switchOutOfSupportActivation() {
    const defaultCompany = companies.find((company) => company.default);
    if (needsCompanyChooser || !defaultCompany?.id) {
      navigate("/choosecompany");
      return;
    }
    await getRefreshedBearerToken(defaultCompany.id);
    dispatch(setCompany(defaultCompany));
    navigate("/supportconsole");
  }

  return (
    <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
      <Typography color="error" sx={{ fontWeight: "bold", lineHeight: 1 }}>
        SUPPORT ACCESS ACTIVATED - ACCT {company.id}
      </Typography>
      <Button
        onClick={switchOutOfSupportActivation}
        variant="outlined"
        color="error"
        sx={{ lineHeight: 1, p: 1 }}
      >
        END SUPPORT SESSION
      </Button>
    </Box>
  );
}
